import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  viewChild,
  input,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'vs-button',
  templateUrl: './button.html',
  styleUrl: './button.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements AfterViewInit {
  text = input<string>('');
  title = input<string>('');
  disabled = input<boolean>(false);
  className = input<string>('');
  icon = input<string>('');
  id = input<string>('button');

  onClick = output<void>();

  input1 = viewChild<ElementRef>('input1');

  onClickBtn(): void {
    this.onClick.emit();
  }

  ngAfterViewInit(): void {
    const inputElement = this.input1();
    if (inputElement) {
      const c = [...inputElement.nativeElement.classList];
      if (c.includes('no')) {
        setTimeout(() => {
          inputElement.nativeElement.focus();
        }, 20);
      }
    }
  }
}
